
import { defineComponent, ref, onMounted, computed, watch } from "vue";
import { usePlugin } from "@/plugins";
import {
  GetWorklistRequest,
  GetWorklistResponse,
  TrainingAttendance,
  PositionDocument,
  TrainingAssessment,
} from "@/types";
import { Dictionary } from "vue-gtag-next";
import { useLocalStorage } from "@vueuse/core";
import StatusBadge from "@/components/StatusBadge.vue";
// import SubmitApprovePanel from "@/components/SubmitApprovePanel.vue";

export default defineComponent({
  name: "Home",
  components: { StatusBadge },
  setup() {
    const {
      axios,
      error,
      success,
      setLoading,
      formatAppDate,
      router,
      useState,
      useSessionState,
    } = usePlugin();
    const showAll = useLocalStorage("Home_showAll", false);
    const dayOptions = [
      { code: 30, description: "30 วันย้อนหลัง" },
      { code: 60, description: "60 วันย้อนหลัง" },
      { code: 90, description: "90 วันย้อนหลัง" },
      { code: -1, description: "ทั้งหมด" },
    ];
    const numberOfDays = useLocalStorage("Home_numberOfDays", 30);

    // const trainingDocuments = ref<TrainingAttendance[]>([]);
    const positionDocuments = ref<PositionDocument[]>([]);
    const assessmentDocuments = ref<TrainingAssessment[]>([]);

    const loadDocuments = async () => {
      setLoading(true);
      try {
        var result = await axios.post<GetWorklistResponse>(
          "api/v1/services/worklist",
          {
            showAll: showAll.value,
            numberOfDays: numberOfDays.value,
          } as GetWorklistRequest
        );
        // trainingDocuments.value = result.data.trainingDocuments ?? [];
        positionDocuments.value = result.data.positionDocuments ?? [];
        assessmentDocuments.value = result.data.trainingAssessments ?? [];
        success("ดึงข้อมูลสำเร็จแล้ว");
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onGoAssessment = (documentId: string) => {
      router.push({
        name: "performTrainingAssessment",
        params: {
          documentId: documentId,
        },
      });
    };
    const onAssessment = (documentId: string, questionId: number) => {
      router.push({
        name: "performAssessment",
        params: {
          documentId: documentId,
          questionId: questionId,
        },
      });
    };
    const onSupervisorAssessment = (
      documentId: string,
      questionId: number,
      employeeId: string
    ) => {
      router.push({
        name: "viewAssessment",
        params: {
          documentId: documentId,
          questionId: questionId,
          employeeId: employeeId,
        },
      });
    };
    const onGoSupervisorAssessment = (
      documentId: string,
      employeeId: string
    ) => {
      router.push({
        name: "viewTrainingAssessment",
        params: {
          documentId: documentId,
          employeeId: employeeId,
        },
      });
    };

    const onPositionAssessment = (documentId: string) => {
      router.push({ name: "positionAssessment", params: { id: documentId } });
    };
    // const trainingDocumentsStatus = computed(() => {
    //   var result: Dictionary<{ status: string; severity: string }> = {};
    //   trainingDocuments.value.map((x) => {
    //     const key = `${x.trainingDocumentId}${x.employeeId}`;
    //     let status = "TBD";
    //     // x.approveOn !== null
    //     //   ? "อนุมัติแล้ว"
    //     //   : x.submitOn != null
    //     //   ? "ส่งเอกสารแล้ว"
    //     //   : "บันทึก";
    //     let severity = "info";
    //     // x.approveOn !== null
    //     //   ? "success"
    //     //   : x.submitOn != null
    //     //   ? "warning"
    //     //   : "info";
    //     result[key] = {
    //       status: status,
    //       severity: severity,
    //     };
    //   });
    //   return result;
    // });
    const state = useState();
    const sessionState = useSessionState();

    const username = computed(() => state.value.authentication.username);
    const onOpenRegisterLink = () => {
      window.location.href = sessionState.value.profile.lineRegisterLink;
    };

    onMounted(() => loadDocuments());
    watch(
      () => showAll.value,
      () => loadDocuments()
    );
    watch(
      () => numberOfDays.value,
      () => loadDocuments()
    );

    return {
      // onDownloadPDF,
      showAll,
      // trainingDocuments,
      // trainingDocumentsStatus,
      positionDocuments,
      assessmentDocuments,
      formatAppDate,
      onGoAssessment,
      onGoSupervisorAssessment,
      onAssessment,
      onSupervisorAssessment,
      onPositionAssessment,
      username,
      dayOptions,
      numberOfDays,
      state,
      sessionState,
      onOpenRegisterLink,
    };
  },
});
